/* @flow */
import React from 'react';
import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';
import styles from './Authorization.module.pcss';

type Props = {
  auth: AuthT,
};

const RegisterResult = ({ auth }: Props) => {
  const message = (
    <>
      <div display-if={auth.profile.organization?.name}>
        Welcome to the <span className={styles.orgName}>{auth.profile.organization?.name}</span> sales portal.
      </div>
      <div>Here, you can add leads, generate documents, and track deal form.</div>
    </>
  );

  const actions = (
    <div className={styles.actions}>
      <Link to="/">
        <Button size="large" type="primary">
          Go To Dashboard
        </Button>
      </Link>
    </div>
  );

  return (
    <Result
      className={styles.registerResult}
      status="success"
      title={<div className={styles.title}>Registration Successful</div>}
      subTitle={message}
      extra={actions}
      style={{ marginTop: 56 }}
    />
  );
};

export default RegisterResult;
